import { useCallback } from 'react';

import { isMobile as useIsMobile } from '@common/device-manager';
import { isZigzag } from '@common/device-manager';
import { DeskTopLandingPopup, MobileLandingPopup, usePopupDialog } from '@common/overlay-manager';
import { Router, useIsAuthenticated } from '@domains/pdp-common';

import { useSizeInfoLoginRedirect } from './useSizeInfoLoginRedirect';

/**
 * 상품 문의하기(사이즈 문의) 공통 핸들러.
 * EmptyView 클릭, 테이블 내 문의하기 등에서 동일 동작을 위해 사용.
 * - 비지그: 랜딩 팝업
 * - 비로그인: 로그인 리다이렉트
 * - 그 외: 문의하기 페이지로 이동 (Router.push)
 */
export const useSizeInquiry = (catalogProductId: string) => {
  const { isLoggedIn } = useIsAuthenticated();
  const { open } = usePopupDialog();
  const isMobile = useIsMobile();
  const { loginWithRedirect } = useSizeInfoLoginRedirect();

  const handleSizeInquiry = useCallback(() => {
    if (!isZigzag()) {
      open(isMobile ? MobileLandingPopup() : DeskTopLandingPopup());
      return;
    }
    if (!isLoggedIn) {
      loginWithRedirect(catalogProductId);
      return;
    }

    const question_url = `/checkout/inquiries/product/new?product_id=${catalogProductId}&from=pdp`;
    Router.push(question_url, { title: '상품 문의하기' });
  }, [isLoggedIn, open, isMobile, loginWithRedirect, catalogProductId]);

  return { handleSizeInquiry };
};
